import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import routesfe from '../Config/RoutesFE';

const RequireAuth = ({ user, children }) => {
  const location = useLocation();

  // If the user is not authenticated, redirect to /login.
  if (!user) {
    return <Navigate to={routesfe.LOGIN} state={{ from: location }} replace />;
  }

  // If the user is authenticated but email is not verified, redirect to /user-verification.
  if (user && !user.attributes.email_verified) {
    return <Navigate to={routesfe.USER_VERIFICATION} state={{ from: location }} replace />;
  }

  // Check subscription and trial status
  const isSubscribed = user?.attributes['custom:is_subscribed'] === "1";
  // Check Cognito attribute OR location state (for immediately after trial activation, before page refresh)
  // OR sessionStorage (for persistent trial flag across route changes within the same session)
  const isTrialUser = user?.attributes['custom:is_trial_user'] === "1" 
    || location.state?.trialJustActivated === true 
    || sessionStorage.getItem('noteforge_trial_activated') === 'true';
  const protectedPaths = [routesfe.HOME, routesfe.CHAT, routesfe.RECORD, routesfe.LIVETRANSCRIPT, routesfe.PROFILE, routesfe.NOTE];
 
  // If user is not subscribed OR not on trial and tries to access protected routes, redirect to /plans
  if (!isSubscribed && !isTrialUser && protectedPaths.includes(location.pathname)) {
    return <Navigate to={routesfe.PLANS} replace />;
  }

  // If user is on /plans and is already subscribed or is a trial user, redirect to /home
  if ((isSubscribed || isTrialUser) && location.pathname === routesfe.PLANS) {
    return <Navigate to={routesfe.HOME} replace />;
  }

  // If user is authenticated and tries to access /payment, only allow if redirected from subscribe (selectedPlan exists)
  if (location.pathname === routesfe.PAYMENT) {
    // Only allow if selectedPlan is present in location.state
    if (!location.state?.selectedPlan) {
      return <Navigate to={routesfe.HOME} replace />;
    }
  }

  // If the user is authenticated and email is verified, render the children.
  return children;
};

export default RequireAuth;
